// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-page {
  --terms-type-heading: clamp(2.2rem, 3.2vw, 3rem);
  --terms-type-subheading: 1.6rem;
  --terms-type-card-heading: 1.2rem;
  --terms-type-body: 1.05rem;
  --terms-type-label: 0.9rem;
  background: #d6c3d9;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  color: #0f172a;
  font-family: 'Inter', sans-serif;
  padding-top: 5.25rem;
}

.terms-hero {
  padding: 2.1rem 1rem 2.2rem;
  max-width: 1320px;
  margin: 0 auto;
}

.hero-path {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
  font-size: var(--terms-type-label);
  color: #64748b;
}

.download-btn {
  background: #e0e7ff;
  border: none;
  border-radius: 999px;
  padding: 0.5rem 1.25rem;
  font-weight: 600;
  color: #1d4ed8;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  cursor: pointer;
}

.hero-title-group h1 {
  font-size: var(--terms-type-heading);
  margin: 0;
}

.hero-title-group p {
  margin: 0.35rem 0 0;
  color: #94a3b8;
  font-size: var(--terms-type-body);
}

.terms-body {
  display: grid;
  grid-template-columns: minmax(220px, 0.9fr) minmax(0, 3.6fr);
  gap: 2rem;
  max-width: 1320px;
  margin: 0 auto 4rem;
  padding: 0 1rem 3rem;
}

.toc {
  background: #fff;
  border-radius: 1.5rem;
  padding: 1.5rem;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08);
  border: 1px solid #e2e8f0;
  position: sticky;
  top: 1.5rem;
  align-self: start;
}

.toc-title {
  font-size: var(--terms-type-label);
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 1rem;
}

.toc ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.toc li a {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: #0f172a;
  font-weight: 600;
  text-decoration: none;
  font-size: var(--terms-type-body);
}

.toc li span {
  font-size: 0.9rem;
  color: #1d4ed8;
  font-weight: 700;
}

.toc-cta {
  margin-top: 2rem;
  padding: 1rem;
  border-radius: 1rem;
  background: #eef2ff;
  color: #370b3b;
  font-size: var(--terms-type-label);
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.link-btn {
  background: transparent;
  border: none;
  color: #1d4ed8;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  text-align: left;
}

.terms-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.terms-section {
  background: #fff;
  border-radius: 1.5rem;
  padding: 2rem;
  box-shadow: 0 25px 50px rgba(15, 23, 42, 0.12);
  border: 1px solid #e2e8f0;
}

.section-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.section-number {
  background: #e0f2fe;
  color: #1d4ed8;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  font-weight: 700;
  font-size: 0.95rem;
}

.terms-section h2 {
  margin: 0;
  font-size: var(--terms-type-subheading);
}

.terms-section p {
  margin-top: 0.65rem;
  color: #370b3b;
  line-height: 1.7;
  font-size: var(--terms-type-body);
}

.terms-kicker {
  font-weight: 700;
  color: #370b3b;
  font-style: italic;
}

.terms-subtitle {
  margin-top: 1.35rem;
  margin-bottom: 0.35rem;
  font-size: var(--terms-type-card-heading);
  color: #370b3b;
}

.terms-table {
  width: 100%;
  margin-top: 0.75rem;
  margin-bottom: 0.6rem;
  table-layout: fixed;
  border-collapse: collapse;
  border: 1px solid #c4b5d6;
  background: #ffffff;
}

.terms-table th,
.terms-table td {
  border: 1px solid #c4b5d6;
  padding: 0.6rem 0.7rem;
  text-align: left;
  vertical-align: top;
  font-size: 0.98rem;
  line-height: 1.45;
  word-break: break-word;
}

.terms-table th {
  background: #e9d5ff;
  color: #370b3b;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0;
}

.terms-note {
  margin-top: 0.5rem;
  color: #6b21a8 !important;
  font-size: 1rem;
  font-style: italic;
}

.terms-list {
  margin-top: 0.75rem;
  padding-left: 1.2rem;
}

.terms-list li {
  margin-bottom: 0.4rem;
  color: black;
  line-height: 1.6;
  font-size: var(--terms-type-body);
}

@media (max-width: 1024px) {
  .terms-body {
    grid-template-columns: 1fr;
    max-width: 100%;
    transform: none;
  }

  .toc {
    position: relative;
    top: 0;
  }

  .terms-hero {
    max-width: 100%;
    transform: none;
  }
}

@media (max-width: 640px) {
  .terms-hero {
    padding-top: 2.5rem;
  }

  .hero-title-group h1 {
    font-size: 2.15rem;
  }

  .terms-section {
    padding: 1.25rem;
    border-radius: 1.2rem;
  }

  .terms-section h2 {
    font-size: 1.35rem;
  }

  .terms-subtitle {
    font-size: 1rem;
  }

  .hero-path {
    flex-direction: column;
    align-items: flex-start;
  }

  .terms-body {
    padding: 0 0.75rem 2rem;
    gap: 1.25rem;
  }

  .toc {
    padding: 1.1rem;
    border-radius: 1.2rem;
  }

  .terms-table th,
  .terms-table td {
    font-size: 0.82rem;
    padding: 0.45rem 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Terms/terms.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;EAChD,+BAA+B;EAC/B,iCAAiC;EACjC,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,8CAA8C;EAC9C,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE;IACE,0BAA0B;IAC1B,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,MAAM;EACR;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;;IAEE,kBAAkB;IAClB,uBAAuB;EACzB;AACF","sourcesContent":[".terms-page {\r\n  --terms-type-heading: clamp(2.2rem, 3.2vw, 3rem);\r\n  --terms-type-subheading: 1.6rem;\r\n  --terms-type-card-heading: 1.2rem;\r\n  --terms-type-body: 1.05rem;\r\n  --terms-type-label: 0.9rem;\r\n  background: #d6c3d9;\r\n  min-height: 100vh;\r\n  width: 100%;\r\n  overflow-x: hidden;\r\n  color: #0f172a;\r\n  font-family: 'Inter', sans-serif;\r\n  padding-top: 5.25rem;\r\n}\r\n\r\n.terms-hero {\r\n  padding: 2.1rem 1rem 2.2rem;\r\n  max-width: 1320px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.hero-path {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n  margin-bottom: 1rem;\r\n  font-size: var(--terms-type-label);\r\n  color: #64748b;\r\n}\r\n\r\n.download-btn {\r\n  background: #e0e7ff;\r\n  border: none;\r\n  border-radius: 999px;\r\n  padding: 0.5rem 1.25rem;\r\n  font-weight: 600;\r\n  color: #1d4ed8;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.hero-title-group h1 {\r\n  font-size: var(--terms-type-heading);\r\n  margin: 0;\r\n}\r\n\r\n.hero-title-group p {\r\n  margin: 0.35rem 0 0;\r\n  color: #94a3b8;\r\n  font-size: var(--terms-type-body);\r\n}\r\n\r\n.terms-body {\r\n  display: grid;\r\n  grid-template-columns: minmax(220px, 0.9fr) minmax(0, 3.6fr);\r\n  gap: 2rem;\r\n  max-width: 1320px;\r\n  margin: 0 auto 4rem;\r\n  padding: 0 1rem 3rem;\r\n}\r\n\r\n.toc {\r\n  background: #fff;\r\n  border-radius: 1.5rem;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08);\r\n  border: 1px solid #e2e8f0;\r\n  position: sticky;\r\n  top: 1.5rem;\r\n  align-self: start;\r\n}\r\n\r\n.toc-title {\r\n  font-size: var(--terms-type-label);\r\n  letter-spacing: 0.2em;\r\n  text-transform: uppercase;\r\n  color: #94a3b8;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.toc ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.toc li a {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  color: #0f172a;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  font-size: var(--terms-type-body);\r\n}\r\n\r\n.toc li span {\r\n  font-size: 0.9rem;\r\n  color: #1d4ed8;\r\n  font-weight: 700;\r\n}\r\n\r\n.toc-cta {\r\n  margin-top: 2rem;\r\n  padding: 1rem;\r\n  border-radius: 1rem;\r\n  background: #eef2ff;\r\n  color: #370b3b;\r\n  font-size: var(--terms-type-label);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.35rem;\r\n}\r\n\r\n.link-btn {\r\n  background: transparent;\r\n  border: none;\r\n  color: #1d4ed8;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  text-align: left;\r\n}\r\n\r\n.terms-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2rem;\r\n}\r\n\r\n.terms-section {\r\n  background: #fff;\r\n  border-radius: 1.5rem;\r\n  padding: 2rem;\r\n  box-shadow: 0 25px 50px rgba(15, 23, 42, 0.12);\r\n  border: 1px solid #e2e8f0;\r\n}\r\n\r\n.section-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.section-number {\r\n  background: #e0f2fe;\r\n  color: #1d4ed8;\r\n  border-radius: 50%;\r\n  width: 44px;\r\n  height: 44px;\r\n  display: grid;\r\n  place-items: center;\r\n  font-weight: 700;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.terms-section h2 {\r\n  margin: 0;\r\n  font-size: var(--terms-type-subheading);\r\n}\r\n\r\n.terms-section p {\r\n  margin-top: 0.65rem;\r\n  color: #370b3b;\r\n  line-height: 1.7;\r\n  font-size: var(--terms-type-body);\r\n}\r\n\r\n.terms-kicker {\r\n  font-weight: 700;\r\n  color: #370b3b;\r\n  font-style: italic;\r\n}\r\n\r\n.terms-subtitle {\r\n  margin-top: 1.35rem;\r\n  margin-bottom: 0.35rem;\r\n  font-size: var(--terms-type-card-heading);\r\n  color: #370b3b;\r\n}\r\n\r\n.terms-table {\r\n  width: 100%;\r\n  margin-top: 0.75rem;\r\n  margin-bottom: 0.6rem;\r\n  table-layout: fixed;\r\n  border-collapse: collapse;\r\n  border: 1px solid #c4b5d6;\r\n  background: #ffffff;\r\n}\r\n\r\n.terms-table th,\r\n.terms-table td {\r\n  border: 1px solid #c4b5d6;\r\n  padding: 0.6rem 0.7rem;\r\n  text-align: left;\r\n  vertical-align: top;\r\n  font-size: 0.98rem;\r\n  line-height: 1.45;\r\n  word-break: break-word;\r\n}\r\n\r\n.terms-table th {\r\n  background: #e9d5ff;\r\n  color: #370b3b;\r\n  font-weight: 700;\r\n  text-transform: none;\r\n  letter-spacing: 0;\r\n}\r\n\r\n.terms-note {\r\n  margin-top: 0.5rem;\r\n  color: #6b21a8 !important;\r\n  font-size: 1rem;\r\n  font-style: italic;\r\n}\r\n\r\n.terms-list {\r\n  margin-top: 0.75rem;\r\n  padding-left: 1.2rem;\r\n}\r\n\r\n.terms-list li {\r\n  margin-bottom: 0.4rem;\r\n  color: black;\r\n  line-height: 1.6;\r\n  font-size: var(--terms-type-body);\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .terms-body {\r\n    grid-template-columns: 1fr;\r\n    max-width: 100%;\r\n    transform: none;\r\n  }\r\n\r\n  .toc {\r\n    position: relative;\r\n    top: 0;\r\n  }\r\n\r\n  .terms-hero {\r\n    max-width: 100%;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .terms-hero {\r\n    padding-top: 2.5rem;\r\n  }\r\n\r\n  .hero-title-group h1 {\r\n    font-size: 2.15rem;\r\n  }\r\n\r\n  .terms-section {\r\n    padding: 1.25rem;\r\n    border-radius: 1.2rem;\r\n  }\r\n\r\n  .terms-section h2 {\r\n    font-size: 1.35rem;\r\n  }\r\n\r\n  .terms-subtitle {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .hero-path {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .terms-body {\r\n    padding: 0 0.75rem 2rem;\r\n    gap: 1.25rem;\r\n  }\r\n\r\n  .toc {\r\n    padding: 1.1rem;\r\n    border-radius: 1.2rem;\r\n  }\r\n\r\n  .terms-table th,\r\n  .terms-table td {\r\n    font-size: 0.82rem;\r\n    padding: 0.45rem 0.5rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
